export default __webpack_public_path__ + "static/media/firedUserCommentAvatar.610d6bba.svg";